






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'
import {InputPosicaoMotoristaSchema} from '@/schema/resource/PosicaoMotorista/InputPosicaoMotoristaSchema'

@Component
export default class PersistPosicaoMotoristaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputPosicaoMotoristaSchema()
  posicaoMotorista = new PosicaoMotorista()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.posicaoMotorista.getPosicaoMotorista(id)
    }

    $.await.done('getPosicaoMotorista')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.posicaoMotorista.persistPosicaoMotorista()
    await Helper.successAndPush(
      'system.success.persist',
      '/posicao-motorista/list'
    )
  }
}
